import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { RippleModule } from 'primeng/ripple';
import { MessageService, PrimeIcons } from 'primeng/api';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { DividerModule } from 'primeng/divider';
import { NGXLogger } from 'ngx-logger';
import { StiliService } from '../../../services/stili.service';
import { EntiEsecutoriService } from '../../../services/entiEsecutori.service';
import { RichiesteService } from '../../../services/richieste.service';
import { GeneraRichiesteRequest } from '../../../models/requests/genera-richieste.model';

@Component({
  selector: 'app-genera-richieste',
  templateUrl: './genera-richieste.component.html',
  styleUrls: ['./genera-richieste.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    TableModule,
    ToastModule,
    CheckboxModule,
    InputTextModule,
    ProgressBarModule,
    RippleModule,
    TagModule,
    TooltipModule,
    DividerModule
  ],
  providers: [MessageService]
})
export class GeneraRichiesteComponent implements OnInit {
  @Input() visible: boolean = false;
  @Input() anno: number = new Date().getFullYear();
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() richiesteGenerate = new EventEmitter<{enteIds: number[], count: number}>();

  entiEsecutori: any[] = [];
  entiSelezionati: any[] = [];
  entesFiltrati: any[] = [];

  caricamentoInCorso: boolean = false;
  progressoCaricamento: number = 0;
  filtroEnte: string = '';

  mostraConferma: boolean = false;
  generazioneInCorso: boolean = false;

  selezionaTutti: boolean = false;

  constructor(
    private entiEsecutoriService: EntiEsecutoriService,
    private messageService: MessageService,
    private logger: NGXLogger,
    public stiliService: StiliService,
    private richiesteService: RichiesteService
  ) {}

  ngOnInit() {
   // //this.logger.info(`[GENERA-RICHIESTE] Genera richieste per l'anno ${this.anno + 1}`);

    this.caricaEntiEsecutori();
  }

  caricaEntiEsecutori() {
    //this.logger.info('[GENERA-RICHIESTE] Caricamento enti esecutori');
    this.caricamentoInCorso = true;

    // Simuliamo un progresso di caricamento
    let progress = 0;
    const intervalId = setInterval(() => {
      progress += 10;
      this.progressoCaricamento = progress;
      if (progress >= 100) {
        clearInterval(intervalId);
      }
    }, 150);

    this.entiEsecutoriService.get().subscribe({
      next: (enti) => {
        this.entiEsecutori = enti;
        this.entesFiltrati = [...this.entiEsecutori];
        this.caricamentoInCorso = false;
       // //this.logger.info(`[GENERA-RICHIESTE] Caricati ${enti.length} enti esecutori`);
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante il caricamento degli enti esecutori',
          life: 3000
        });
        this.caricamentoInCorso = false;
        this.logger.error('[GENERA-RICHIESTE] Errore caricamento enti', error);
      }
    });
  }

  onHide() {
    // Blocca la chiusura se la generazione è in corso
    if (this.generazioneInCorso) {
      return;
    }

    this.visibleChange.emit(false);
    this.reset();
  }

  reset() {
    this.entiSelezionati = [];
    this.filtroEnte = '';
    this.entesFiltrati = [...this.entiEsecutori];
    this.selezionaTutti = false;
    this.mostraConferma = false;
    this.generazioneInCorso = false;
  }

  filtraEnti() {
    if (!this.filtroEnte.trim()) {
      this.entesFiltrati = [...this.entiEsecutori];
    } else {
      const filtro = this.filtroEnte.toLowerCase().trim();
      this.entesFiltrati = this.entiEsecutori.filter(ente =>
        ente.label.toLowerCase().includes(filtro) ||
        ente.categoria.descrizione.toLowerCase().includes(filtro)
      );
    }
  }

  toggleSelezionaTutti() {
    if (this.selezionaTutti) {
      this.entiSelezionati = [...this.entesFiltrati];
    } else {
      this.entiSelezionati = [];
    }
  }

  isSelezionato(ente: any): boolean {
    return this.entiSelezionati.findIndex(e => e.id === ente.id) !== -1;
  }

  toggleSelezioneEnte(ente: any) {
    const index = this.entiSelezionati.findIndex(e => e.id === ente.id);
    if (index === -1) {
      this.entiSelezionati.push(ente);
    } else {
      this.entiSelezionati.splice(index, 1);
    }

    // Aggiorna stato "seleziona tutti" in base alle selezioni attuali
    this.selezionaTutti = this.entesFiltrati.length > 0 &&
      this.entesFiltrati.every(ente => this.isSelezionato(ente));
  }

  proseguiConGenerazione() {
    if (this.entiSelezionati.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Attenzione',
        detail: 'Seleziona almeno un ente per generare le richieste',
        life: 3000
      });
      return;
    }

    this.mostraConferma = true;
  }

  generaRichieste() {
    if (this.entiSelezionati.length === 0) return;

    this.generazioneInCorso = true;
    const enteIds = this.entiSelezionati.map(ente => ente.id);
    let generaRichieste: GeneraRichiesteRequest = {
      enti: enteIds,
      anno: this.anno +1
    };
    // Simuliamo il processo di generazione
     // //this.logger.info(`[GENERA-RICHIESTE] Generate richieste per ${enteIds.length} enti per l'anno ${this.anno +1}`);
      this.richiesteService.generaRichieste(generaRichieste).subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Operazione completata',
            detail: `Generate ${enteIds.length} richieste per l'anno ${this.anno +1}`,
            life: 5000
          });
          this.richiesteGenerate.emit({
            enteIds: enteIds,
            count: enteIds.length
          });
          this.generazioneInCorso = false;
          this.visible = false;
          this.visibleChange.emit(false);
          this.reset();
        },
        error: (error) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Errore',
            detail: `Errore durante la generazione delle richieste`,
            life: 5000
          });
          this.generazioneInCorso = false;
          this.visible = false;
          this.visibleChange.emit(false);
          this.reset();
        }
      });


  }

  annullaConferma() {
    this.mostraConferma = false;
  }



  getCategorieSummary() {
    // Raggruppa gli enti selezionati per categoria
    const categorieMap = new Map<string, { nome: string, count: number }>();

    this.entiSelezionati.forEach(ente => {
      const categoriaKey = ente.categoria.codice;
      const categoriaNome = ente.categoria.descrizione;

      if (categorieMap.has(categoriaKey)) {
        const categoria = categorieMap.get(categoriaKey);
        if (categoria) {
          categoria.count++;
        }
      } else {
        categorieMap.set(categoriaKey, {
          nome: categoriaNome,
          count: 1
        });
      }
    });

    // Converti la mappa in un array per l'utilizzo nel template
    return Array.from(categorieMap.values());
  }
}
